import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import * as _ from "lodash";
import * as angular from "angular";
import { House } from "../../models/house.model";
import { HouseService } from "../../services/house.service";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { HouseHelperService } from "./house.helper";
import { BuildingDataProvider } from "../../data-provider/building.dp";
import { Campaign } from "../../models/campaign.model";
import {
    dwellingTypes,
    homeOwnerStatuses,
    householdNetWorths,
} from "../../utils/constants/fields.constants";
import { prospectorEditDisabledMessage } from "../../utils/constants/prospector.constants";
import { PermissionCheck } from "../../shared/permission";

declare const google;

let HouseFormComponent = {
    selector: "vcHouseForm",
    templateUrl: "/angular/components/house/house-form.component.html",
    bindings: {
        selectedHouse: "=?",
        center: "=?",
        zoom: "=?",
    },
    controller: class HouseFormController {
        // * bindings for typescript compiler *
        public selectedHouse?: House;
        public center?: any;
        public zoom?: any;
        // ************************************

        private $scope: any;
        private $rootScope: any;
        private toast: ToastUtils;
        private $timeout: any;
        private service: HouseService;
        private buildingDataProvider: BuildingDataProvider;
        private uiGmapGoogleMapApi: any;
        private uiGmapIsReady: any;
        private helperService: HouseHelperService;
        private dialog: DialogUtils;
        private __env: any;
        private modelsUtils: any;

        private house: House;
        private showMap = false;
        private saving = false;
        private originalHouseMarker: any = null;
        private newHouseURL = "";
        private map: any;
        private houseMarker: any;
        private markerEvents: object | undefined = undefined;
        private locationError: string | null = null;
        private locating: boolean | undefined = undefined;
        private address_changed: boolean | undefined = undefined;
        private timeoutCode: any;
        private delayInMs = 500;
        private existHouseURL: string | null;
        private activeCampaign: Campaign;
        private addressChangedFromPinDrag: boolean = false;
        public editHouse: House;
        public isBuilding: boolean = false;
        public keepDialogOpen: boolean = false;
        public houseForm: any;
        public reverseGeocoding: boolean = false;
        public permissionProvider: PermissionCheck;

        public netWorths: string[] = householdNetWorths;
        public dwellingTypes: string[] = dwellingTypes;
        public homeOwnerStatuses: string[] = homeOwnerStatuses;
        public prospectorEditDisabledMessage: string =
            prospectorEditDisabledMessage;

        constructor(
            $scope: any,
            $rootScope: any,
            ToastUtils: ToastUtils,
            $timeout: object,
            HouseHelperService: HouseHelperService,
            uiGmapGoogleMapApi: any,
            uiGmapIsReady: any,
            HouseService: HouseService,
            DialogUtils: DialogUtils,
            BuildingDataProvider: BuildingDataProvider,
            CampaignDataProvider: CampaignDataProvider,
            PermissionCheck: PermissionCheck,
            __env: object,
            ModelsUtils: any
        ) {
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.toast = ToastUtils;
            this.$timeout = $timeout;
            this.service = HouseService;
            this.permissionProvider = PermissionCheck;
            this.uiGmapGoogleMapApi = uiGmapGoogleMapApi;
            this.uiGmapIsReady = uiGmapIsReady;
            this.helperService = HouseHelperService;
            this.dialog = DialogUtils;
            this.__env = __env;
            this.modelsUtils = ModelsUtils;
            this.buildingDataProvider = BuildingDataProvider;
            this.activeCampaign = CampaignDataProvider.activeCampaign;

            this.$timeout(() => {
                this.showMap = true;
            }, 500);
        }

        $onInit() {
            this.house = _.cloneDeep(this.selectedHouse);

            if (this.house) {
                this.center =
                    this.house.hlatitude && this.house.hlongitude
                        ? {
                              latitude: this.house.hlatitude,
                              longitude: this.house.hlongitude,
                          }
                        : { latitude: 0, longitude: 0 };

                this.zoom =
                    this.house.hlatitude && this.house.hlongitude ? 16 : 3;
            } else if (
                this.activeCampaign.localInfo &&
                this.activeCampaign.localInfo.map
            ) {
                this.center = this.center ??
                    this.activeCampaign.localInfo.map.center ?? {
                        latitude: 0,
                        longitude: 0,
                    };
                this.zoom =
                    this.zoom ?? this.activeCampaign.localInfo.map.zoom ?? 3;
            } else {
                this.center = {
                    latitude: 0,
                    longitude: 0,
                };

                this.zoom = 3;
            }

            if (
                this.house &&
                this.house.constructor &&
                this.house.constructor.name == "Building"
            ) {
                this.isBuilding = true;
            }

            this.editHouse = this.modelsUtils.house(_.cloneDeep(this.house));
            if (this.editHouse && this.editHouse.bid == null) {
                this.$scope.$watch(
                    () => this.editHouse,
                    (newValue: House, oldValue: House) => {
                        this.houseForm.$setPristine();
                        if (
                            !this.addressChangedFromPinDrag &&
                            newValue &&
                            oldValue
                        ) {
                            clearTimeout(this.timeoutCode); //does nothing, if timeout already done
                            this.timeoutCode = setTimeout(() => {
                                if (!this.locating) {
                                    if (
                                        newValue &&
                                        newValue.haddress &&
                                        newValue.hcity &&
                                        newValue.hstate
                                    ) {
                                        if (
                                            this.helperService.addressDifferent(
                                                newValue,
                                                oldValue
                                            )
                                        ) {
                                            if (newValue !== oldValue) {
                                                this.existHouseURL = null;
                                                this.locate();
                                            }
                                        }
                                    }
                                }
                            }, this.delayInMs);
                        } else {
                            this.addressChangedFromPinDrag = false;
                        }
                    },
                    true
                );
            }
        }

        loadMap(): void {
            this.uiGmapGoogleMapApi.then(() => {
                this.map = {
                    bounds: {},
                    center: angular.copy(this.center),
                    zoom: this.zoom,
                    control: {},
                };

                this.houseMarker = {
                    id: 1,
                    coords: angular.copy(this.center),
                    options: {
                        draggable:
                            this.editHouse.bid == null &&
                            !this.editHouse.isProspectorHouse(),
                    },
                };

                this.reverseGeocode();

                this.markerEvents = {
                    dragstart: (event) => {
                        this.setOriginalMarker();
                    },
                    dragend: (event) => {
                        this.pinDragged();
                        this.reverseGeocode();
                    },
                };
                this.initialiseMarker();
            });
        }

        reverseGeocode() {
            if (
                this.editHouse.hid ||
                (this.isBuilding && this.editHouse.id) ||
                this.editHouse.bid
            ) {
                return;
            }

            this.reverseGeocoding = true;
            this.helperService.reverseGeocode(
                this.houseMarker.coords.latitude,
                this.houseMarker.coords.longitude,
                (address: any) => {
                    if (address && Object.values(address).some((v) => v)) {
                        this.editHouse = this.modelsUtils.house(address);
                        this.addressChangedFromPinDrag = true;
                    }
                    this.reverseGeocoding = false;
                },
                () => {
                    this.reverseGeocoding = false;
                }
            );
        }

        setOriginalMarker(): void {
            // house had a original location and there isn't a marker for it.
            if (
                !this.originalHouseMarker &&
                this.house &&
                this.house.hlatitude &&
                (this.house.hlatitude + "").trim() != "" &&
                this.house.hlongitude &&
                (this.house.hlongitude + "").trim() != ""
            ) {
                this.originalHouseMarker = {
                    id: 2,
                    coords: {
                        latitude: this.house.hlatitude,
                        longitude: this.house.hlongitude,
                    },
                    options: {
                        title:
                            this.editHouse.bid == null
                                ? "Original Location"
                                : "Building Location",
                        icon: "http://maps.google.com/mapfiles/ms/micons/blue.png",
                    },
                };
            }
        }

        initialiseMarker(): void {
            this.originalHouseMarker = null;
            if (
                this.house &&
                this.house.hlatitude &&
                (this.house.hlatitude + "").trim() != "" &&
                this.house.hlongitude &&
                (this.house.hlongitude + "").trim() != ""
            ) {
                this.houseMarker = {
                    id: 1,
                    coords: {
                        latitude: this.house.hlatitude,
                        longitude: this.house.hlongitude,
                    },
                    options: {
                        draggable: this.editHouse.bid == null,
                    },
                };
            }
            this.setMapCenter();
        }

        setMapCenter(): void {
            // no markers anywhere show the world
            if (!this.houseMarker && !this.originalHouseMarker) {
                this.map.center = {
                    latitude: 0,
                    longitude: 0,
                };
                this.map.zoom = 1;
            }
            // both markers calculate bounds
            else if (this.houseMarker && this.originalHouseMarker) {
                let bounds = new google.maps.LatLngBounds();
                let glatlng1 = new google.maps.LatLng(
                    this.houseMarker.coords.latitude,
                    this.houseMarker.coords.longitude
                );
                bounds.extend(glatlng1);
                let glatlng2 = new google.maps.LatLng(
                    this.originalHouseMarker.coords.latitude,
                    this.originalHouseMarker.coords.longitude
                );
                bounds.extend(glatlng2);
                this.map.bounds = {
                    southwest: {
                        latitude: bounds.getSouthWest().lat(),
                        longitude: bounds.getSouthWest().lng(),
                    },
                    northeast: {
                        latitude: bounds.getNorthEast().lat(),
                        longitude: bounds.getNorthEast().lng(),
                    },
                };
            } else if (
                this.houseMarker &&
                this.houseMarker.coords.latitude != 0 &&
                this.houseMarker.coords.longitude != 0 &&
                this.houseMarker.coords.latitude != this.center.latitude &&
                this.houseMarker.coords.longitude != this.center.longitude
            ) {
                this.map.center = _.cloneDeep(this.houseMarker.coords);
            } else if (this.originalHouseMarker) {
                this.map.center = _.cloneDeep(this.originalHouseMarker.coords);
            }
        }

        locate(): void {
            if (this.editHouse.bid != null) {
                this.setOriginalMarker();
                this.houseMarker = {
                    id: 1,
                    locationtype: this.editHouse.hlocationtype,
                    coords: {
                        latitude: this.editHouse.hlatitude,
                        longitude: this.editHouse.hlongitude,
                    },
                    options: {
                        title: "Building Location",
                        draggable: false,
                    },
                };
                this.setMapCenter();
                return;
            }
            this.locationError = null;
            this.locating = true;
            let addressData = _.cloneDeep(this.editHouse);
            addressData.occupants = null;
            this.helperService.locate(
                addressData,
                (location: any) => {
                    this.locating = false;
                    if (
                        this.editHouse.hlatitude != location.coords.latitude ||
                        this.editHouse.hlongitude != location.coords.longitude
                    ) {
                        this.address_changed = true;
                        this.setOriginalMarker();
                        this.houseMarker = {
                            id: 1,
                            locationtype: location.locationtype,
                            coords: location.coords,
                            options: {
                                title: "Suggested Location",
                                draggable: true,
                            },
                        };
                        this.setMapCenter();
                    }
                },
                (error: any) => {
                    this.locating = false;
                    if (error.hlocationtype === "ZERO_RESULTS") {
                        this.locationError =
                            "Could not find coordinates for that address.";
                    } else {
                        this.locationError =
                            "Could not connect to Google Maps right now";
                    }
                }
            );
        }

        confirmNewLocation(): void {
            this.originalHouseMarker = null;
            if (this.houseMarker && this.houseMarker.coords) {
                this.address_changed = false;
                this.editHouse.hlatitude = this.houseMarker.coords.latitude;
                this.editHouse.hlongitude = this.houseMarker.coords.longitude;
                if (angular.isUndefined(this.houseMarker.locationtype)) {
                    this.editHouse.hlocationtype = "Manual";
                } else {
                    this.editHouse.hlocationtype =
                        this.houseMarker.locationtype;
                }
            } else {
                this.editHouse.hlocationtype = null;
            }
        }

        saveHouse(): void {
            if (this.isBuilding) {
                this.updateBuilding();
            } else if (this.house && this.house.hid) {
                this.updateHouse();
            } else {
                this.createHouse();
            }
        }

        updateBuilding(): void {
            if (
                !this.house.hlocationtype ||
                (this.house.hlatitude == 0 && this.house.hlongitude == 0)
            ) {
                this.confirmNewLocation();
            }
            this.saving = true;

            this.buildingDataProvider.update(this.editHouse).then(
                (house: object) => {
                    this.closeDialog(house);
                    this.saving = false;
                    this.toast.success("House updated.");
                },
                (json: any) => {
                    if (json.message == "Address already exist") {
                        this.toast.error(
                            "A building with this address already exists, and building address must be unique"
                        );
                    } else {
                        this.toast.error(
                            "Something went wrong, please try again or contact " +
                                this.__env.support_email
                        );
                    }
                }
            );
        }

        updateHouse(): void {
            if (
                !this.house.hlocationtype ||
                (this.house.hlatitude == 0 && this.house.hlongitude == 0)
            ) {
                this.confirmNewLocation();
            }
            this.saving = true;
            this.editHouse.update().then(
                (house: object) => {
                    this.closeDialog(house);
                    this.saving = false;
                    this.toast.success("House updated.");
                },
                (json: any) => {
                    if (json.message == "Address already exist") {
                        this.openViewHouseDialog(json.hid);
                        this.toast.error("This house already exists");
                    } else {
                        this.toast.error(
                            "Something went wrong, please try again or contact " +
                                this.__env.support_email
                        );
                    }
                }
            );
        }

        createHouse(): void {
            if (
                this.address_changed &&
                this.houseMarker.coords &&
                this.houseMarker.coords.latitude
            ) {
                this.editHouse.hlatitude = this.houseMarker.coords.latitude;
                this.editHouse.hlongitude = this.houseMarker.coords.longitude;
            }

            this.saving = true;
            this.service.create(this.editHouse).then((response: object) => {
                const json = response["data"];

                if (!this.keepDialogOpen) {
                    angular.extend(this.editHouse, json.data);
                    this.dialog.hide(this.editHouse);
                }
                this.saving = false;
                if (json.success) {
                    this.toast.success(
                        this.editHouse.formatAddressLine1() + " created."
                    );
                    if (!this.keepDialogOpen) {
                        this.confirmNewLocation();
                        this.openViewHouseDialog(json.id);
                    }
                } else if (json.message == "Address already exist") {
                    this.openViewHouseDialog(json.hid);
                    this.toast.error(
                        this.editHouse.formatAddressLine1() + " already exists"
                    );
                } else {
                    this.toast.error(
                        "Something went wrong, please try again or contact " +
                            this.__env.support_email
                    );
                }
            });
        }

        openViewHouseDialog(hid: string | number, ev?: object): void {
            this.dialog.show({
                component: "vc-view-house",
                targetEvent: ev,
                skipHide: true,
                clickOutsideToClose: true,
                scope: this.$rootScope,
                ariaLabel: "View House",
                size: "large",
                locals: {
                    selectedHid: hid,
                    selectedHouse: null,
                },
            });
        }

        pinDragged(): void {
            if (this.editHouse.hid || (this.isBuilding && this.editHouse.id))
                this.address_changed = true;
        }

        resetMarker(): void {
            this.address_changed = false;
            this.initialiseMarker();
        }

        closeDialog(house: object) {
            this.dialog.hide(house);
        }

        dismissDialog() {
            this.dialog.cancel();
        }
    },
};

angular
    .module("house")
    .component(HouseFormComponent.selector, HouseFormComponent);
